import {ItemIconDict} from "../../../../gd/const/item-icon/icon/icons";
import Document from "../../../../model2/doc/document"
import {DocumentSystemType} from "../../../../model2/doc/types";

export default function getDocumentIcon(document: Document) {
    const noteType = gd.session.noteTypes.get(document.noteTypeId)
    // default icon for cases when no note type found i.e. deleted and no missign data
    // const icon = noteType ? gd.const.note.icon[noteType.icon] : 'ii5-file-text'

    if (noteType) {
        return ItemIconDict[noteType.icon].className
    } else {

        if (
            document.systemType === DocumentSystemType.WHITEBOARD
            || document.systemType === DocumentSystemType.WHITEBOARD_RESOURCE
        ) {
            return "i5-whiteboard"
        } else {
            return  "i5-task-list"
        }
    }

}
